import { render } from "./CardImg.vue?vue&type=template&id=aa23e6de"
import script from "./CardImg.vue?vue&type=script&lang=js"
export * from "./CardImg.vue?vue&type=script&lang=js"
script.render = render

export default script